import partnerService from "@/services/partnerService";

const defaultSettings = {
    allow_bxl_resi: 0
}

export default {
    async getPartnerSettings(partnerCode) {
        if (!partnerCode) {
            return defaultSettings;
        }
        
        const partnerUppercase = partnerCode.toUpperCase();
        if (partnerUppercase.startsWith('AG')) {
            try {
                const settings = await partnerService.getPartnerSettings(partnerCode);
                return settings;
            } catch (error) {
                return defaultSettings;
            }
        } else {
            return defaultSettings;
        }
    }
};


// WEBPACK FOOTER //
// ./src/helpers/partnerHelpers.js